<template>
    <div
        class="eq-toolbar"
        role="toolbar"
    >
        <div
            class="d-flex gap-1 align-items-end"
            v-if="(actions && actions.length > 0) || $slots.first"
        >
            <slot name="first">
                <ButtonGroup
                    :actions="actions"
                    v-if="actions?.length"
                />
            </slot>
        </div>
        <div class="flex-grow-1 d-flex gap-1 align-items-end">
            <slot name="middle">
                <SearchBox
                    v-if="searchText !== undefined"
                    :placeholder="searchBoxPlaceholder ? $tm(searchBoxPlaceholder) : ''"
                    v-model="searchText"
                    :searchstate="searchstate"
                    @searching="(value: string, event: KeyboardEvent) => emits('searching', value)"
                    class="w-100"
                />
            </slot>
        </div>
        <div class="d-flex gap-1 align-items-end">
            <ButtonGroup
                v-if="rightActions?.length"
                :actions="rightActions"
            />
            <slot
                name="last"
                v-if="$slots.last"
            >
            </slot>
        </div>
    </div>
</template>
<script setup lang="ts">
import type { DropdownItemTypes } from '@/objects';
import { ButtonGroup, SearchBox } from '@/components';
import type { TaskLoaderState } from '@/composeables';
import { $tm } from '@/locize';

defineProps<{
    actions?: DropdownItemTypes[];
    rightActions?: DropdownItemTypes[];
    searchBoxPlaceholder?: string;

    /**
     * We can set the search state to show a spinner in the box while we are searching
     */
    searchstate?: TaskLoaderState;
}>();

const searchText = defineModel<string>('searchtext');

const emits = defineEmits<{ (e: 'searching', value: string): void }>();
</script>
